import { l } from '@manychat/manyui'

import { SECONDS_IN_HOUR } from 'components/DelayPicker/constants'
import {
  LiveChatThread as LiveChatThreadSchema,
  LiveChatThreadUser,
} from 'shared/api/requests/chat/threads/schemas'

import { BaseSocketEvent, LiveChatNote, SocketBulkActionsTypes } from './LiveChatInterfaces'

export const ThreadSuccessBulkText = {
  [SocketBulkActionsTypes.ASSIGN]: l.makeTranslate('Conversations have been assigned.'),
  [SocketBulkActionsTypes.UNASSIGN]: l.makeTranslate('Conversations have been unassigned.'),
  [SocketBulkActionsTypes.CLOSE]: l.makeTranslate('Conversations have been closed.'),
  [SocketBulkActionsTypes.REOPEN]: l.makeTranslate('Conversations have been reopened.'),
}

export enum ThreadMessageType {
  MSG_IN = 'msgin',
  MSG_OUT = 'msgout',
}

export const DelayAutomationsOptions = [
  { label: l.makeTranslate('30 minutes'), value: SECONDS_IN_HOUR / 2 },
  { label: l.makeTranslate('1 hour'), value: SECONDS_IN_HOUR },
  { label: l.makeTranslate('3 hours'), value: SECONDS_IN_HOUR * 3 },
  { label: l.makeTranslate('6 hours'), value: SECONDS_IN_HOUR * 6 },
  { label: l.makeTranslate('12 hours'), value: SECONDS_IN_HOUR * 12 },
  { label: l.makeTranslate('1 day'), value: SECONDS_IN_HOUR * 24 },
]

export const PauseForeverOption = { label: l.makeTranslate('Forever'), value: -1 }

export const DelayAutomationsMap: Record<number, ReturnType<typeof l.makeTranslate>> = {
  [SECONDS_IN_HOUR / 2]: l.makeTranslate('30 minutes'),
  [SECONDS_IN_HOUR]: l.makeTranslate('1 hour'),
  [SECONDS_IN_HOUR * 3]: l.makeTranslate('3 hours'),
  [SECONDS_IN_HOUR * 6]: l.makeTranslate('6 hours'),
  [SECONDS_IN_HOUR * 12]: l.makeTranslate('12 hours'),
  [SECONDS_IN_HOUR * 24]: l.makeTranslate('1 day'),
  [PauseForeverOption.value]: PauseForeverOption.label,
}

export enum AutomationsStatus {
  WORKING = 'working',
  PAUSED = 'paused',
  PAUSED_FOREVER = 'paused-forever',
}

export type ChatThreadUser = LiveChatThreadUser

export interface LiveChatThread<ChatLastEvent = BaseSocketEvent<UnsafeAnyObject>>
  extends Omit<LiveChatThreadSchema, 'last_lc_event'> {
  id: string
  last_lc_event: ChatLastEvent | null
  notes?: LiveChatNote[] | null
  score_rating?: number
}

export interface PauseAutomationsData {
  id: string
  pausedUntil?: ChatThreadUser['ts_automation_paused_until']
  isPausedForever?: ChatThreadUser['ts_automation_paused_forever']
}
